export const LIST_POST_RATING = 'LIST_POST_RATING'
export const POST_RATING_STATS = 'POST_RATING_STATS'
